import { query, mutate } from '../../apollo/client';

export async function getSkills() {
  const { default: getSkillsQuery } = await import('../../graphql/skills/getSkills');

  const response = await query(getSkillsQuery, null, false);
  return {
    hard: response.data.getSkills.hard,
    hardAlias: response.data.getSkills.hardAlias,
    soft: response.data.getSkills.soft,
    languageCommon: response.data.getSkills.languageCommon,
    languageRare: response.data.getSkills.languageRare
  };
}

export async function getSkillRoles() {
  const { default: getSkillRolesQuery } = await import('../../graphql/skills/getSkillRoles');

  const response = await query(getSkillRolesQuery, null, false);
  return response.data.getSkillRoles;
}

export async function getSkillRoleBySlug(slug) {
  const { default: getSkillRoleBySlugQuery } = await import('../../graphql/skills/getSkillRoleBySlug');

  const response = await query(getSkillRoleBySlugQuery, { slug }, false);

  return response.data.getSkillRoleBySlug;
}

/**
 * @param {string} territory
 */
export async function getDefaultLanguages(territory) {
  const { default: getDefaultLanguagesQuery } = await import('../../graphql/mission/getDefaultLanguages');

  const response = await query(getDefaultLanguagesQuery, { territory }, false);
  return response.data.getDefaultLanguages;
}
